<template>
	<error-page status="401" title="Unauthorized">
		<p>
			Sign in and try again.
		</p>
		<btn primary raised :to="{ name: 'login' }">Sign in</btn>
	</error-page>
</template>


<script>
	export default {
		name: 'unauthorized',
		methods: {
			goBack() {
				this.$router.go(-1);
			}
		}
	};
</script>
